export const INDICATORS_TO_FIX_CONST = {
    MERC_COMP_DISP: 1,
    MERC_COMP_GEN: 2,
    PIZ_DISP: 3,
    FORW_COMP: 4,
    FORW_GEN: 5,
    MATBA: 6,
    CME: 7,
    CME_EN_MATBA: 8,
    DISP_MATBA: 9,
};

export const CONDITIONS_TYPE_TO_FIX_CONST = {
    TRADICIONAL: 1,
    PASE_COSECHA: 2,
    PORCENTAJE_PRODUCTO: 3,
    SIN_ESPACIO: 4,
};

export const PLACES_TO_FIX_CONST = {
    ROSARIO: 5,
    UP_RIVER: 90001,
    ROSARIO_NORTE: 1500,
    ROSARIO_SUR: 1501,
    BAHIA_BLANCA: 1,
    NECOCHEA: 132,
    DARSENA: 22,
};
